import CryptoJS from "crypto-js";
import AES from "crypto-js/aes";
const secretKey = "zxdfgfhrhrshrgtratgrsgrgtztryrty67x";

export const capitalizeAllLetters = (inputString) => inputString?.toUpperCase();

export const formatNumberWithFraction = (value, fractionDigits = 1) =>
  value?.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

export const formatNumberRoundOff = (value, fractionDigits = 1) => {
  if (value < 100) {
    // Return the original value without rounding
    return value.toFixed(fractionDigits);
  }

  const roundedValue = Math.ceil(value / 1000) * 1000; // Round to the nearest thousand
  const formattedValue = roundedValue.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  return formattedValue;
};

export const formatDashDate = (shift_date) => {
  const changedate = shift_date.split("/");
  const date = `${changedate[1]}-${changedate[0]}-${changedate[2]}`;
  return date;
};

export const formatDecimalTarget = (num) => {
  if (isNaN(num) || num === null || num === undefined) return "";
  return parseFloat((Math.trunc(num * 1000) / 1000).toString());
};

export const formatOneDecimalTarget = (num) => {
  if (isNaN(num) || num === null || num === undefined) return "";
  return parseFloat((Math.trunc(num * 10) / 10).toString());
};

export const decryptedFunction = (dataToEncrypt) => {
  if (process.env.React_App_ENVIRONMENT == "production") {
    //   if (process.env.React_App_ENVIRONMENT == "development") {
    var bytes = CryptoJS.AES.decrypt(dataToEncrypt, secretKey);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } else {
    //  var bytes = CryptoJS.AES.decrypt(dataToEncrypt, secretKey);
    //  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    //  return decryptedData;

    return dataToEncrypt;
  }
};

export const dataEnCrypt = (data) => {
  if (process.env.React_App_ENVIRONMENT == "production") {
    //   if (process.env.React_App_ENVIRONMENT == "development") {
    return AES.encrypt(JSON.stringify(data), secretKey).toString();
  } else {
    // return AES.encrypt(JSON.stringify(data), secretKey).toString();

    return data;
  }
};


export const ssodecrypted = (data) => {
  const env = process.env.React_App_ENVIRONMENT;
  const encryptionIV = process.env.REACT_APP_SECRET_IV
  const encryptionKey = process.env.REACT_APP_SECRET_KEY

  const key = CryptoJS.enc.Hex.parse(encryptionKey);
  const iv = CryptoJS.enc.Hex.parse(encryptionIV);

  try {
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Hex.parse(data) },
      key,
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    console.warn("Failed to decrypt data:", e);
    return data;
  }
};
